import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useAdminStore } from "../../../../store/adminStore";
import { asignarSolicitudesHandler, getInspectoresHandler } from "../handlers";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import BadgeEstadoActa from "../../../../components/BadgeEstadoActa";
import Loading from "../../../../components/Loading";
import { CSVLink } from "react-csv";

const ActionBar = ({ setCambio }) => {
  const {
    inspectores,
    asignarInspector,
    setAsignarInspector,
    inspectorAsignado,
    setInspectorAsignado,
    solicitudesAsignar,
    setEstadoActas,
    estado_actas,
    setSearchInspector,
    searchInspector,
    actas,
    setFiltroFecha,
    filtroFecha,
    toggleFecha,
    setToggleFecha,
  } = useAdminStore();
  const { loads } = useGeneralAppStore();

  const headers = [
    { label: "ID", key: "id" },
    { label: "Fecha", key: "fecha_solicitud" },
    { label: "Solicitante", key: "solicitante" },
    { label: "Domicilio", key: "domicilio" },
    { label: "Barrio", key: "barrio" },
    { label: "Sector", key: "sector" },
    { label: "Genero", key: "genero" },
    { label: "Edad", key: "edad" },
    { label: "Documento", key: "dni" },
    { label: "Telefono", key: "telefono" },
    { label: "Email", key: "email" },
  ];

  const opciones = [
    { id: 1, estado: 5, nombre: "Inspeccion" },
    { id: 2, estado: 10, nombre: "Pendiente aceptar" },
    { id: 3, estado: 2, nombre: "Aceptadas" },
    { id: 4, estado: 8, nombre: "Finalizadas" },
    { id: 5, estado: 3, nombre: "Rechazadas" },
  ];

  useEffect(() => {
    // if (asignarInspector && !inspectores) {
    //     getInspectoresHandler();
    // }
    if (!inspectores) {
      getInspectoresHandler();
    }
  }, [asignarInspector]);

  useEffect(() => {
    if (toggleFecha) {
      setFiltroFecha;
    }
  }, [toggleFecha]);

  return (
    <div className="border py-2 px-4 d-flex flex-column ">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-4">
          <Form.Group>
            <Form.Label>Estado de solicitud</Form.Label>
            <Form.Select
              defaultValue={estado_actas}
              onChange={(e) => {
                setCambio(true);
                setEstadoActas(e.target.value);
                setAsignarInspector(false);
              }}
            >
              {opciones?.map((opc) => {
                return (
                  <option key={opc.id} value={opc.estado}>
                    {opc.nombre}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
          <div className="">
            <Form.Group>
              <Form.Check
                className="mb-2"
                type={"checkbox"}
                label={"Filtrar por fecha?"}
                onChange={(e) => {
                  e.target.checked ? setToggleFecha(true) : setToggleFecha(null);
                  setCambio(true);
                }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Control
                disabled={!toggleFecha}
                type="date"
                defaultValue={filtroFecha}
                onChange={(e) => {
                  setFiltroFecha(e.target.value);
                  setCambio(true);
                }}
              ></Form.Control>
            </Form.Group>
          </div>
        </div>

        <CSVLink
          style={{ textDecoration: "none" }}
          headers={headers}
          filename={`Solicitudes${toggleFecha ? "-" + filtroFecha : ""}-${
            estado_actas == 5
              ? "Pendientes de inspeccion"
              : estado_actas == 9
              ? "Incompletas"
              : estado_actas == 2
              ? "Aceptadas"
              : estado_actas == 8
              ? "Finalizadas"
              : estado_actas == 3
              ? "Rechazadas"
              : estado_actas == 10
              ? "Pendientes aceptar"
              : "No elegida"
          }.csv`}
          data={actas}
          separator={";"}
        >
          <div
            className="btn btn-light d-flex gap-2 align-items-center my-auto me-1"
            style={{ maxHeight: "38px" }}
          >
            <span style={{ color: "#0D8448", textDecoration: "nome", fontSize: "16px" }}>
              Descargar registro{/* Listado */}
            </span>
            <img
              src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
              alt="excel"
              style={{ height: 24 }}
            />
          </div>
          {/* <img src={excelLogo} alt="excel-logo" /> */}
        </CSVLink>
      </div>
      <hr />
      <div className="d-flex gap-4 align-items-center position-relative">
        {estado_actas == 5 ? (
          <Button
            disabled={loads.includes("inspectores")}
            size="md"
            variant={asignarInspector ? "primary" : "secondary"}
            onClick={() => {
              if (!asignarInspector && searchInspector != "all") {
                setSearchInspector("all");
              }
              setAsignarInspector(!asignarInspector);
            }}
          >
            Asignar Inspector
          </Button>
        ) : (
          <div style={{ height: "35.98px" }} />
        )}

        {asignarInspector && (
          <div className="d-flex align-items-center gap-2">
            <Form.Group>
              {/* <Form.Label>Sector</Form.Label> */}
              <Form.Select
                disabled={loads.includes("inspectores")}
                size="sm"
                onChange={(e) =>
                  setInspectorAsignado(e.target.value)
                } /* isInvalid={!!errors.barrio_id} {...register("sector")} */
              >
                <option value="">Seleccione un inspector</option>
                {inspectores?.map((inspector) => (
                  <option key={inspector.id} value={inspector.usuarioID}>
                    {inspector.nombre}
                  </option>
                ))}
              </Form.Select>
              {/* <Form.Control.Feedback className="mensajeError-sm mensajeError-md" type="invalid">
                            {errors.sector?.message}
                        </Form.Control.Feedback>
                        {!errors.sector?.message && <div style={{ height: "25px" }}></div>} */}
            </Form.Group>
            <Button
              disabled={solicitudesAsignar.length == 0}
              size="sm"
              onClick={() =>
                asignarSolicitudesHandler({
                  usuario_id: inspectorAsignado,
                  solicitudes: solicitudesAsignar,
                })
              }
            >{`Asignar ${solicitudesAsignar.length} solicitudes`}</Button>
          </div>
        )}
      </div>
      <hr className="mb-2" />
      <div className="d-flex justify-content-between position-relative w-100 align-items-center">
        {/* <div className="position-absolute" style={{ left: 0 }}> */}
        <BadgeEstadoActa estado={estado_actas} />
        <div className="d-flex  gap-2">
          {searchInspector != "all" && (
            <CSVLink
              style={{ textDecoration: "none" }}
              headers={headers}
              filename={`${actas[0]?.inspector?.nombre}-listado-solicitudes.csv`}
              data={actas}
              separator={";"}
            >
              <div
                className="btn btn-light d-flex gap-2 align-items-center my-auto me-1"
                style={{ maxHeight: "38px" }}
              >
                <span style={{ color: "#0D8448", textDecoration: "nome", fontSize: "16px" }}>
                  Descargar {/* Listado */}
                </span>
                <img
                  src="https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png"
                  alt="excel"
                  style={{ height: 24 }}
                />
              </div>
              {/* <img src={excelLogo} alt="excel-logo" /> */}
            </CSVLink>
          )}
          {!asignarInspector && (
            <Form.Select
              size="md"
              onChange={(e) => {
                setSearchInspector(e.target.value);
              }}
            >
              <option value="all">Seleccione un inspector</option>
              {inspectores?.map((inspector) => (
                <option key={inspector.id} value={inspector.usuarioID}>
                  {inspector.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
